import {validation} from "../helpers/validation";

let href = location.href

// $(document).on('click', '.js-send-email', function(e) {
//     e.preventDefault();
//     let form = $('.js-email-form')
//     let obj = {
//         name: $('.js-email-name').val(),
//         email: $('.js-email-email').val(),
//         question: $('.js-email-question').val(),
//         question_theme_id: $('.js-email-question-theme-id').val(),
//     }
//     $.ajax({
//         url: form.data('url'),
//         type: 'POST',
//         data: obj,
//         success: function(data) {
//             window.notify('Your email has been sent', 'success')
//         },
//         error: function (xhr) {
//             window.notify('Your email has not been sent', 'error')
//             let response = JSON.parse(xhr.responseText);
//             console.log('xhr',response.errors)
//
//             validation(form[0], response.errors, true);
//         }
//     });
// })


if (href.includes('/login') || href.includes('/sigh-in') || href.includes('/register') || href.includes('/password/reset') || href.includes('/home')  || href.includes('/client/model')) {

    $('.js-contacts__block').addClass('d-none')
} else {
    $('.js-contacts__block').removeClass('d-none')
}

$('input').each((index, item) => {
    $(item).on('input', e => {
        $(e.target).parent('div').find('.error-text').html('')
        $(e.target).removeClass('is-invalid')
    })
})

$('textarea').each((index, item) => {
    $(item).on('input', e => {
        $(e.target).parent('div').find('.error-text').html('')
        $(e.target).removeClass('is-invalid')
    })
})
